import { Component, inject } from '@angular/core';
import { SystemSettingService } from '../../services/system.setting.service';
import { RegisterComponent } from '../component-lookup';

@RegisterComponent('ToggleComponent')
@Component({
  selector: 'app-toggle',
  standalone: true,
  imports: [],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss'
})
export class ToggleComponent {

  public years: number = 0;
  private systemSettingService = inject(SystemSettingService);
  public isTruncationChecked: boolean = false;
  public isAdjustedForCovidChecked: boolean = false;


  ngOnInit(): void {
    this.systemSettingService.getSystemSettingValue("nmd_trunct")
      .subscribe(value => {
        this.years = Number(value) / 4;
      });

    const truncationValue = this.systemSettingService.getSelectedSystemSetting();
    this.isTruncationChecked = truncationValue !== undefined;

    const covidAdjusted = this.systemSettingService.getAdjustedForCovid();
    this.isAdjustedForCovidChecked = covidAdjusted;
  }

  onTruncationToggleChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    isChecked ? this.changeSystemVariable("nmd_trunct") : this.changeSystemVariable(undefined);
    this.isTruncationChecked = isChecked;
  }

  changeSystemVariable(key: string | undefined) {
    this.systemSettingService.setSelectedSystemSetting(key)
  }

  onCovidToggleChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    isChecked ? this.changeCovidStatus(true) : this.changeCovidStatus(false);
    this.isAdjustedForCovidChecked = isChecked;
  }

  changeCovidStatus(adjusted: boolean) {
    this.systemSettingService.setAdjustForCovid(adjusted);
  }

}
